import styled from 'styled-components';
import { Button, Form } from 'antd';
import MaskedInput from 'antd-mask-input';

// Tema restrito aos controles da área de acesso.
export const loginTheme = {
  token: {
    colorPrimary: '#24a95d',
    colorText: '#173747',
    colorTextPlaceholder: '#65757d',
    colorIcon: '#596b75',
    colorIconHover: '#173747',
    colorBgContainer: '#ffffff',
    borderRadius: 8,
    controlHeightLG: 52,
  },
  components: {
    Form: { labelColor: '#f4f7f8', itemMarginBottom: 22 },
    Input: { paddingInlineLG: 16 },
  },
};

export const LayoutComp = styled.main`
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(420px, 1fr);
  min-height: 100vh;
  min-height: 100dvh;
  background: #0d364a;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const VisualPanel = styled.aside`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  padding: clamp(32px, 5vw, 80px);
  background: #092b3b;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 35%, rgba(4, 25, 36, 0.92));
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 510px;
  color: #fff;

  h2 {
    margin: 20px 0 16px;
    color: inherit;
    font-size: clamp(32px, 3.4vw, 54px);
    font-weight: 600;
    letter-spacing: -1.5px;
    line-height: 1.12;
  }

  p {
    max-width: 420px;
    margin: 0;
    color: #d5e3e9;
    font-size: 17px;
    line-height: 1.7;
  }
`;

export const Eyebrow = styled.div`
  color: ${loginTheme.token.colorPrimary};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const AccessPanel = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 56px clamp(32px, 5vw, 80px);

  @media (max-width: 900px) {
    min-height: 100vh;
    min-height: 100dvh;
  }

  @media (max-width: 480px) {
    padding: 36px 24px;
  }
`;

export const AccessContent = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
`;

export const Brand = styled.header`
  margin-bottom: 44px;
`;

export const Logo = styled.img`
  display: block;
  width: 250px;
  max-width: 100%;
  height: auto;
`;

export const FormHeading = styled.div`
  margin-bottom: 28px;

  h1 {
    margin: 0 0 10px;
    color: #fff;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: -0.7px;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: #c5d5dd;
    font-size: 15px;
    line-height: 1.6;
  }
`;

export const FormAntd = styled(Form)`
  width: 100%;

  .ant-form-item-label {
    padding-bottom: 8px;
  }

  .ant-input-prefix {
    margin-inline-end: 12px;
  }

  .ant-input:-webkit-autofill {
    -webkit-text-fill-color: #173747;
    caret-color: #173747;
  }
`;

// A biblioteca de máscara usa antd/lib/input e não recebe o tema do antd/es.
export const CpfInput = styled(MaskedInput)`
  && {
    min-height: ${loginTheme.token.controlHeightLG}px;
    padding-inline: ${loginTheme.components.Input.paddingInlineLG}px;
    color: ${loginTheme.token.colorText};
  }

  &::placeholder,
  input::placeholder {
    color: ${loginTheme.token.colorTextPlaceholder};
    opacity: 1;
  }
`;

export const PrimaryButton = styled(Button)`
  && {
    width: 100%;
    min-height: 52px;
    border: 1px solid ${loginTheme.token.colorPrimary};
    border-radius: 8px;
    background: ${loginTheme.token.colorPrimary};
    color: #0d364a;
    font-size: 16px;
    font-weight: 600;
  }

  &&:hover,
  &&:focus-visible {
    border-color: ${loginTheme.token.colorPrimary};
    background: ${loginTheme.token.colorPrimary};
    color: #0d364a;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  && {
    border-color: #7895a3;
    background: transparent;
    color: #f4f7f8;
  }

  &&:hover,
  &&:focus-visible {
    border-color: ${loginTheme.token.colorPrimary};
    background: #17475c;
    color: ${loginTheme.token.colorPrimary};
  }
`;

export const LinkButton = styled(Button)`
  && {
    height: auto;
    padding: 4px 0;
    color: ${loginTheme.token.colorPrimary};
    white-space: normal;
  }

  &&:hover,
  &&:focus-visible {
    color: ${loginTheme.token.colorPrimary};
    text-decoration: underline;
  }
`;

export const CenteredAction = styled.div`
  margin-top: 18px;
  text-align: center;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 28px 0;
  color: #c5d5dd;
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #446575;
  }
`;

export const AccessFooter = styled.p`
  margin: 36px 0 0;
  color: #aec4cf;
  font-size: 12px;
  text-align: center;
`;

export const FeedbackPanel = styled.div`
  margin-bottom: 24px;
  padding: 24px;
  border: 1px solid #446575;
  border-radius: 8px;
  background: #123f53;
`;

// Cadastro e confirmação continuam usando seu próprio layout.
export const Wrapper = styled.div`
  min-height: 100vh;
  background: #0d364a;
  display: flex;
  align-items: center;
  justify-content: center;
`;
